import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetLineAnimComponent } from './widget-line-anim.component';



@NgModule({
  declarations: [WidgetLineAnimComponent],
  imports: [
    CommonModule
  ],
  exports:[WidgetLineAnimComponent]
})
export class WidgetLineAnimModule { }
